// extracted by mini-css-extract-plugin
var _1 = "PageLayout-module__animateUploadProgressBarWidth--eGBWv";
var _2 = "PageLayout-module__animatedBackground--BHhNK";
var _3 = "PageLayout-module__content--biYcV";
var _4 = "PageLayout-module__inner--yhkQg";
var _5 = "PageLayout-module__isPublicVariant--pRRDL";
var _6 = "PageLayout-module__isSidebarOpen--HnlRk";
var _7 = "PageLayout-module__main--Qiixw";
var _8 = "PageLayout-module__noPaddingX--YdOn6";
var _9 = "PageLayout-module__noPaddingY--NFP0l";
var _a = "PageLayout-module__overlay--BIM6x";
var _b = "PageLayout-module__shouldShiftContentForSidebar--OwqoK";
var _c = "PageLayout-module__sidebar--LzsPC";
var _d = "150ms";
var _e = "PageLayout-module__topbar--ZONcr";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "content", _4 as "inner", _5 as "isPublicVariant", _6 as "isSidebarOpen", _7 as "main", _8 as "noPaddingX", _9 as "noPaddingY", _a as "overlay", _b as "shouldShiftContentForSidebar", _c as "sidebar", _d as "sidebarTransitionDuration", _e as "topbar" }
